(function(){
  'use strict';

  angular.module('clientDashboardApp.admin.updates', ['clientDashboardApp.admin.updates.updateConfirmation']);
  angular.module('clientDashboardApp.admin.updates.updateConfirmation', ['clientDashboardApp.admin.updates.updateService']).directive('updateConfirmation', updateConfirmation);

  function updateConfirmation(){
    return {

      restrict : 'A',
      template: require('./updateConfirmationAlert.html'),
      scope : {
        updateConfig: '=',
        searchParam : '=',
        refresh : '&'
      },
      controller: UpdateConfirmationController,
      controllerAs : 'vm'
    }
  }

  UpdateConfirmationController.$inject = ['$scope','updateService','stringService','adminSearchService','adminPageInfo', '$location', 'accountsService','userService'];

  function UpdateConfirmationController($scope, updateService, stringService, adminSearchService, adminPageInfo, $location, accountsService, userService) {

    var vm = this;
    var permissions = [];

    userService.currentUser().then(function(userInfo){
      permissions = userInfo.permissions;
      vm.locationManager = _.intersection(permissions, ['AddLocation', 'EditLocation', 'DeleteLocation']).length > 0;
      vm.groupManager = _.contains(permissions, 'GroupManagement');
      vm.userManager = _.contains(permissions, 'UserManagement');
      vm.chatmeterAdmin = _.contains(permissions, 'GlobalAccess');
      vm.accountManager = userInfo.userType == 'ResellerAdmin';

      if (adminPageInfo.pageTypeChange() || (adminPageInfo.pageModeChange() && adminPageInfo.getPreviousPageInfo().mode == 'manage')) {
        updateService.resetUpdateStatus();
      }

      refreshUpdateDetails();

      $scope.$watch(function () {
        return updateService.getUpdateDetails();
      }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          refreshUpdateDetails();
        }
      },1);

    });

    vm.pageInfo = adminPageInfo.getCurrentPageInfo();
    vm.showAlert = false;
    vm.accountFlowLinks = [
      {
        origin: "account",
        type: "location",
        title: "Create a new location for this account?",
        path: "/admin/v2/locations/create",
        hide: true
      },
      {
        origin: "location",
        type: "user",
        title: "Create a new user?",
        path: "/admin/v2/users/create",
        hide: true
      },
      {
        origin: "user",
        type: "userLocation",
        title: "Assign locations to this user?",
        path: "/admin/v2/users/:userId/locations",
        hide: true
      }
    ];

    vm.hideAlert = function () {
      vm.showAlert = false;
    }

    vm.navigateToEditorPage = function (link) {
      if (link.origin == "account") {
        accountsService.setCurrentAccount(vm.updateDetails.id);
      }
      if (link.origin == "user") {
        link.path = link.path.replace(":userId", vm.updateDetails.id);
      }
      $location.path(link.path);
    }

    vm.pluralizeTitle = function(cleanTitle,total){
      return total == 1 ? cleanTitle : cleanTitle + "s";
    }

    vm.isReviewGenPage = function(){
     return $location.path().search(/\/reviewBuilder/g) >= 0;
    }


    function refreshUpdateDetails(updateDetails) {
      vm.currentAccountFlowLinks = angular.copy(vm.accountFlowLinks);
      vm.updateDetails = updateService.getUpdateDetails();

      if (vm.updateDetails.status == "Active" && vm.updateDetails.destinationRole == vm.pageInfo.mode && vm.updateDetails.type == vm.pageInfo.type) {
        vm.showAlert = true;
        vm.pageStrings = stringService.adminStrings();

        if ($scope.updateConfig) {
          $scope.updateConfig.entityId = vm.updateDetails.id;
        }
        else {
          $scope.$watch('updateConfig', function (newVal, oldVal) {
            if (newVal !== oldVal) {
              newVal.entityId = vm.updateDetails.id;
            }
          })
        }

        _.each(vm.currentAccountFlowLinks, function (item) {
          if (item.origin == vm.updateDetails.type && !isAdminUserUpdate() && !hasDeleteAction() && hasCreateAction() && userHasPermission()) {
            item.hide = false;
          }
        });

        vm.isHybridPage = vm.updateDetails.type == "userLocation" || vm.updateDetails.type == "userGroup" || vm.updateDetails.type == "groupLocation";
        vm.managerUpdate = vm.updateDetails.id;
        if ($scope.updateConfig) {
          $scope.updateConfig.entityId = vm.updateDetails.id;
        }
      }
    }

    function userHasPermission() {
      if(vm.updateDetails.type=="location"){
        return _.contains(permissions, 'UserManagement');
      }
      else if(vm.updateDetails.type=="user"){
        return _.contains(permissions, 'EditLocation');
      }
      else{
        return false;
      }
    }

    function hasCreateAction() {
      return _.where(vm.updateDetails.actions,{action: "create"}).length > 0;
    }

    function hasDeleteAction() {
      return _.where(vm.updateDetails.actions,{action: "delete"}).length > 0;
    }

    function isAdminUserUpdate() {
      return vm.updateDetails.type == "user" && vm.updateDetails.entity.userType !== "Standard";
    }

    vm.searchForUpdatedItem = function () {
      adminSearchService.setSearchQuery(vm.updateDetails.searchParam);
      $scope.refresh();
    }

  }

})();

